
import Element2 from "../../../assets/filled/Element2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Element2Icon({ className, dataTestid = "Element2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Element2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
